import { AirtableService } from '@/services/airtable.service';
export default {
  props: {
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      },
      deliveryaddress: ''
    };
  },
  watch: {
    async showDialog(show) {
      if (show) {
        this.deliveryaddress = this.order['Delivery Address'] || this.order['Temp Address'];
      } else {
        this.deliveryaddress = '';
      }
    }
  },
  methods: {
    showAlert(message) {
      this.alert.message = message;
      this.alert.show = true;
    },
    async submitChanges() {
      this.alert.show = false;
      try {
        this.buttonDisabled = true;
        const newOrder = await AirtableService.updateAddress(this.order['Prescription ID'], this.deliveryaddress);
        this.$emit('update:order', newOrder);
        this.$emit('refresh-self', this.order['Prescription ID']);
        this.showDialog = false;
      } catch (err) {
        this.showAlert(err);
      } finally {
        this.buttonDisabled = false;
      }
    }
  }
};